import React, { useState, useContext } from 'react'
import { Menu, MenuItem, Divider } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import classnames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { clearUnsavedChanges } from 'state/unsavedChanges/actions'
import { AuthContext } from 'contexts/auth'
import { Permissions } from 'api'
import { FETCH_CALENDAR_PREFERENCE } from 'state/calendarPreference/actions'
import { selectUnsavedChangesState } from 'state/unsavedChanges/selectors'

import Link from 'components/atoms/link'
import Avatar from 'components/molecules/avatar'
import SwitchOrganisationButton from '../switchOrganisationButton'
import UserInfo from './userInfo'
import UnsavedChangesModal from 'components/molecules/unsavedChangesModal'

import QAPVars from 'qap/vars'
import {
  USER_CALENDAR_PREFERENCE_URL,
  USER_EMAIL_PREFERENCE_URL,
} from 'qap/constants'

import SwitchOrganisation from '../switchOrganisation'

import type { ElementRef } from 'react'

const styles = (theme: any) => ({
  avatar: {
    cursor: 'pointer',
  },

  menu: {
    zIndex: theme.zIndex.tooltip + 1,
  },

  displayContainer: {
    cursor: 'default',
    pointerEvents: 'none',
  },

  divider: {
    borderTop: `solid 2px ${QAPVars.pdfHeaderIconGray}`,
    marginTop: theme.spacing(1),
  },
})

type GuardedAction = 'logout' | 'switchOrganisation'

type MenuProps = {
  classes: any;
  menuRef: ElementRef<any>;
};

const CurrentUserMenu = ({
  classes,
  menuRef,
}: MenuProps) => {
  const [open, setOpen] = useState(false)
  const [displayOrg, setDisplayOrg] = useState(false)
  const [guardedAction, setGuardedAction] =
    useState<GuardedAction | null>(null)

  const {
// @ts-expect-error - TS2339 - Property 'user' does not exist on type 'unknown'.
    user,
// @ts-expect-error - TS2339 - Property 'logoutUser' does not exist on type 'unknown'.
    logoutUser,
// @ts-expect-error - TS2339 - Property 'canSwitchOrganisations' does not exist on type 'unknown'.
    canSwitchOrganisations,
// @ts-expect-error - TS2339 - Property 'selectedOrganisations' does not exist on type 'unknown'.
    selectedOrganisations = [],
// @ts-expect-error - TS2339 - Property 'authorization' does not exist on type 'unknown'.
    authorization,
  } = useContext(AuthContext)

  const { isDirty } = useSelector(selectUnsavedChangesState)
  const dispatch = useDispatch()

  const canSubscribeCalendar = Permissions.isOperationPermitted(
    authorization,
    FETCH_CALENDAR_PREFERENCE,
  )
  const userPreferenceUrl =
    canSubscribeCalendar ?
      USER_CALENDAR_PREFERENCE_URL
    : USER_EMAIL_PREFERENCE_URL

  const toggle = () => {
    setOpen(!open)
  }

  const toggleOrgSwitcher = () => {
    setOpen(false)
    setDisplayOrg(!displayOrg)
  }

  const openOrgSwitcher = () => {
    setOpen(false)

    if (isDirty) {
      setGuardedAction('switchOrganisation')
      return
    }

    setDisplayOrg(true)
  }

  const handleLogout = () => {
    setOpen(false)

    if (isDirty) {
      setGuardedAction('logout')
      return
    }

    logoutUser()
  }

  const handleConfirmUnsaved = () => {
    const action = guardedAction
    setGuardedAction(null)

    if (action === 'switchOrganisation') {
      setDisplayOrg(true)
      return
    }

    dispatch(clearUnsavedChanges())
    logoutUser()
  }

  const handleCancelUnsaved = () => {
    setGuardedAction(null)
  }

  return (
    <>
      <SwitchOrganisationButton
        selectedOrganisations={selectedOrganisations}
        toggleOrgSwitcher={openOrgSwitcher}
      />

{ /* @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'. */}
      <div id='notification-config' ref={menuRef}>
        <Avatar className={classes.avatar} onClick={toggle} user={user} />
      </div>

      {displayOrg && canSwitchOrganisations && <SwitchOrganisation onClose={toggleOrgSwitcher} />}

      <Menu
// @ts-expect-error - TS18046 - 'menuRef' is of type 'unknown'.
        anchorEl={menuRef.current}
        open={Boolean(open)}
        onClose={toggle}
        PopoverClasses={{ root: classes.menu }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem className={classes.displayContainer}>
          <UserInfo user={user} />
        </MenuItem>
        <MenuItem className={classnames(classes.divider, classes.displayContainer)}>
          <Divider />
        </MenuItem>
        {canSwitchOrganisations && (
          <MenuItem onClick={openOrgSwitcher}>
            Switch organisation
          </MenuItem>
        )}
{ /* @ts-expect-error - TS2322 - Type '{ children: Element; to: string; onClick: () => void; hideUnderline: true; }' is not assignable to type 'IntrinsicAttributes & Omit<Props & RefAttributes<null>, "classes"> & StyledComponentProps<"root" | "hideUnderline"> & object'. */}
        <Link to={userPreferenceUrl} onClick={() => setOpen(false)} hideUnderline>
          <MenuItem>Preferences</MenuItem>
        </Link>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      <UnsavedChangesModal
        open={guardedAction !== null}
        onConfirm={handleConfirmUnsaved}
        onCancel={handleCancelUnsaved}
      />
    </>
  )
}

// @ts-expect-error - TS2345 - Argument of type '(theme: any) => { avatar: { cursor: string; }; menu: { zIndex: any; }; displayContainer: { cursor: string; pointerEvents: string; }; divider: { borderTop: string; marginTop: any; }; }' is not assignable to parameter of type 'Styles<any, any, string>'.
export default withStyles(styles)(CurrentUserMenu)
